import { ISearchParameters, ITableReport } from "./TableInterfaces";

export enum CollateralTabs {
  AdaptationManagement, // مدیریت تطبیق
  AdaptationReport, // گزارش تطبیق
  CoveredCall, // وضعیت وثیقه
}

export interface IAdaptationManagementConfig {
  middleDayStart: string;
  middleDayStartISO: string;
  middleDayInterval: number;
  closeDayTime: string;
  closeDayTimeISO: string;
  telorance: number;
  minMarginTotalRatio: number;
}

export interface IAdaptationReportSearchParams {
  accountId: number;
  intrumentId: string;
  baseInstrumentId: string;
  triggerId: number;
}

export interface IFreezedCoveredCallSearchParams extends ISearchParameters {
  instrumentId: string;
  accountId: number;
}

export interface IFreezedCoveredCallTableReport extends ITableReport {
  userid: number;
  baseinstrumentid: string;
}

export interface ISendManualCMDDTO {
  userid: number;
  baseinstrumentid: string;
  id?: number;
}
